// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditImageModal_modal__3y4tD","form":"EditImageModal_form__3iQXv","avatar":"EditImageModal_avatar__1uSj4"};